// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--S4Io5","link":"_9e1425b4d3--link--Q6zct","text":"_9e1425b4d3--text--wppwq","delimiter":"_9e1425b4d3--delimiter--tj5y0"};